module.exports = __webpack_public_path__ + "img/img12.9e2724d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/case/06/img12.png
// module id = 252
// module chunks = 0